var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9987 0.399902C7.83203 0.399902 0.332031 7.88324 0.332031 17.0999C0.332031 25.4333 6.43203 32.3499 14.3987 33.5999V21.9333H10.1654V17.0999H14.3987V13.4166C14.3987 9.23324 16.882 6.93324 20.6987 6.93324C22.5154 6.93324 24.4154 7.2499 24.4154 7.2499V11.3666H22.3154C20.2487 11.3666 19.5987 12.6499 19.5987 13.9666V17.0999H24.232L23.482 21.9333H19.5987V33.5999C23.526 32.9796 27.1024 30.9758 29.6819 27.9499C32.2614 24.9243 33.6744 21.0759 33.6654 17.0999C33.6654 7.88324 26.1654 0.399902 16.9987 0.399902Z",
    fill: "#FF5D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookOrange);
export default __webpack_public_path__ + "static/media/FacebookOrange.4522dc1ee7c6f511b6df363d672633d8.svg";
export { ForwardRef as ReactComponent };